export const LOGIN_ROUTE = '/login';
export const VERIFY_OTP_ROUTE = '/login/verify-otp';
export const HOME_ROUTE = '/';
